import { BaseComponent } from '../../lib/base-component.js';
import { css, html } from '../../lib/lit.js';

// An unmatched path renders this rather than redirecting to '/'. The redirect is
// what d3-auth's router does, and it would take someone whose invite link is a
// character off — the one audience with no account and no way to sign in — and
// silently drop them on the staff sign-in screen.
class NotFoundView extends BaseComponent {
    static styles = css`
        .wrap {
            max-width: 36rem;
            margin: 0 auto;
            padding: 4rem 1rem;
            text-align: center;
        }
    `;

    render() {
        return html`
            <div class="wrap">
                <h1 class="h4">Page not found</h1>
                <p class="text-muted">
                    If you followed an invitation link, check that you copied all of it — or ask
                    whoever invited you to send a new one.
                </p>
            </div>
        `;
    }
}

customElements.define('d3-not-found-view', NotFoundView);
